<template>
    <div class="m-pop">
        <div class="pop-mask"></div>
        <div class="pop-con">
            <div class="title">
                <h3>使用帮助</h3>
                <div class="close" @click="close">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="info-box">
                <div class="info">
                    <h3>组装步骤</h3>
                    <p>1. 从配件库选择灯罩、灯杯、灯架、灯座各1个</p>
                    <p>2. 系统自动优先匹配兼容配件，确保模型可组合</p>
                    <p>3. 点击「生成3D产品」查看效果</p>
                </div>
                <div class="info">
                    <h3>3D视图操作</h3>
                    <p>· 左键拖动：旋转模型</p>
                    <p>· 滚轮：缩放模型</p>
                    <p>· 右键拖动：平移模型</p>
                    <p>· 保存作品后可查看配件尺寸</p>
                </div>
                <div class="info">
                    <h3>组合规则</h3>
                    <p>· 需各选1个灯罩、灯杯、灯架、灯座，系统优先匹配兼容性</p>
                    <p>· 组合仅为视觉效果，可能存在错位现象</p>
                    <p>· 平台不保证组合后的产品可实际安装于室内，需谨慎参考</p>
                </div>
            </div>
            <div class="bot-btn">
                <el-button type="primary" @click="close">知道了</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {
        close: function () {
            this.$emit('close')
        },
        openReg: function () {
            this.$emit('openReg')
        }
    }
}
</script>


<style scoped lang="scss">


</style>
